import AlarmTypes from "./alarmTypes"

export default {
    custAlarms: {
        custAlarms: "Alarmas de clientes",
        alarmDefs: "Definiciones de alarma",
        activeAlarms: "Alarmas activas",
        metricsList: "Lista de alarmas activas",
        metricsDashboard: "Panel de alarmas activas"
    },
    alarmsDashboard: {
        title: "Panel de Alarmas",
        groupBy: "Agrupar Por",
        severityLabel: "Severidad",
        alarmTypeLabel: "Tipo",
        alarmSeverity: 'Gravedad de la alarma',
        alarmCounts: "Recuentos de alarmas activas",
        alarmCountsByDevice: "Recuentos de alarmas por ID de fuente",
        alarmCountsByDay: "Recuentos de alarmas por día",
        alarmCountsByAge: "Recuentos de alarmas por edad",
        alarmCountsByDeviceGraphLabel: "Contar",
        alarmCountsByAgeGraphLabel: "Contar",
        widgets: {
            alarmCount: {
                title: "Alarma Cuenta"
            },
            alarmCountByAge: {
                title: "La alarma cuenta por edad",
                yAxisLabel: "Cuenta",
                xAxisLabel: "Edad (Días)"
            },
            alarmCountByDevice: {
                title: "Recuentos de alarmas por ID de fuente",
                yAxisLabel: "Cuenta",
                xAxisLabel: "Identificación de la fuente"
            },
            alarmCountByDay: {
                title: "La alarma cuenta por día",
                yAxisLabel: "Cuenta",
                xAxisLabel: "Día"
            }
        },
        lang: "ES",
        severities: {
            SEV10: "Crítico",
            SEV20: "Mayor",
            SEV30: "Menor",
            SEV40: "Información",
            SEV50: "Desconocida"
        },
        alarmType: AlarmTypes.alarmTypes
    },
    alarmsTrans: {
        critical: "Crítico",
        major: "Mayor",
        minor: "Menor",
        info: "Info",
        none: "Ninguna"
    },
    alarm: {
        alarmMenu: "Administrar alarmas",
        rule: "Regla",
        goToAlarmDetails: "Ir a Detalles de alarma",
        alarmDefMappings: {
            createSuccess: "La definición de alarma se creó correctamente",
            createFail: "No se puede crear la definición de alarma",
            editSuccess: "La definición de alarma se editó correctamente",
            editFail: "No se puede editar la definición de alarma",
            overrideSuccess: "La definición de alarma global se anuló correctamente",
            overrideFail: "No se puede anular la definición de alarma global",
            activateSuccess: "Definiciones de alarma seleccionadas activadas con éxito",
            activateFail: "No se pueden activar las definiciones de alarma seleccionadas",
            deactivateSuccess: "Las definiciones de alarma seleccionadas se desactivaron correctamente",
            deactivateFail: "No se pueden desactivar las definiciones de alarma seleccionadas",
            deleteSuccess: "Definición de alarma seleccionada eliminada con éxito",
            deleteFail: "No se puede eliminar la definición de alarma seleccionada",
            nameReq: "Debes darle un nombre a tu alarma",
            severityReq: "Necesitas seleccionar una severidad",
            numberReq: "Debes ingresar un número",
            statReq: "Debes seleccionar una estadística",
            freqReq: "Debes seleccionar una frecuencia",
            baseStationReq: "Debe ingresar un ID de estación base",
            operReq: "Debes seleccionar un operador",
            thresholdReq: "Debe incluir un valor umbral",
            clearReq: "Debe incluir un valor claro",
            threshClearInvalid: "El valor umbral debe ser {operator} valor claro",
            threshClearInvalidStandardDeviation: "El valor claro debe ser >= valor umbral y ambos deben ser mayores que cero",
            clearSuccess: "Las alarmas para esta definición se borraron con éxito",
            clearFail: "No se pueden borrar las alarmas para esta definición",
            reqFilterMissing: "Falta el filtro requerido {name}",
            valueRequired: "Valor requerido",
            stdDevRangeError: "La desviación estándar debe ser > 0 y <= 10",
            stdDevClearError: "El umbral de desviación estándar debe ser mayor que la desviación estándar clara",
            percentageRangeError: "El porcentaje debe ser > 0 y <= 100",
            percentageClearError: "El porcentaje de umbral debe ser mayor que el porcentaje claro",
            changeOptOutSuccess: "La configuración de exclusión voluntaria se cambió correctamente",
            changeOptOutFail: "Error en el cambio de configuración para optar por no participar"
        },
        sev: {
            SEV40: "Informacion",
            SEV30: "Menor",
            SEV20: "Mayor",
            SEV10: "Crítico"
        },
        actions: {
            create: "Crear definición de alarma",
            edit: "Editar definiciones de alarma seleccionadas",
            delete: "Eliminar la definición de alarma seleccionada",
            activate: "Activar definiciones de alarma seleccionadas",
            deactivate: "Desactivar definiciones de alarma seleccionadas",
            clear: "Borrar alarmas para la definición de alarma seleccionada",
            downloadCsv: "Descargar alarmas CSV",
            override: "Anular la alarma global"
        },
        detailActions: {
            actions: "Comportamiento",
            ack: "Reconocer",
            unack: "No reconocido",
            ignore: "Ignorar",
            unignore: "No ignorar",
            clear: "Clara"
        },
        detailActionsSubTitle: 'Acciones de alarma',
        createDlogTitle: "Crear nueva alarma",
        editDlogTitle: "Editar alarma",
        overrideDlogTitle: "Anular la alarma global",
        dlog: {
            name: "Nombre",
            severity: "Gravedad",
            description: "Descripción",
            descriptionHint: "Describe tu alarma aquí.",
            thresholdValue: "Valor umbra*",
            lastHeardThresholdValue: "Valor umbral (minutos)",
            percentageThresholdValue: "Valor umbral (porcentaje, 1-100)",
            clearValue: "Valor claro",
            frequency: "Frecuencia",
            baseStation: "Estación Base ID",
            baseStationSearchPlaceholder: "Buscar por estación base id o nombre ...",
            baseStationSearchNoMatches: "No se encontraron coincidencias",
            baseStationSearchSearching: "Buscando coincidencias ...",
            isStdDev: "Usar desviación estándar",
            statistic: {
                label: "Estadística",
                statList : {
                    title: "statList",
                    itemValue: "value",
                    itemText: "text"
                }
            },
            operator: "Operadora",
            value: "Valor",
            disabledClearTooltip: "= y != El operador no necesita un valor claro",
            lastHeardOperatorTooltip: "Las últimas reglas escuchadas deben usar >=",
            standardDeviationDescriptionPlaceholder: "Alarma creada cuando X desviaciones estándar cruzan Y.",
            descriptionPlaceholder: "Alarma creada cuando X cruza Y.",
            trafficDrop: {
                stdDevMulti: "Multiplicador de desarrollo estándar",
                percentageDrop: "Caída porcentual",
            }
        },
        dialogActions: {
            cancel: "Cancelar",
            saveInactive: "Guardar como inactivo",
            saveActive: "Guardar y activar"
        },
        general: "General",
        status: "Estado",
        rules: "Normas",
        confirmDelete: "¿Está seguro de que desea eliminar la regla?",
        canOptOut: "Permitir la exclusión voluntaria",
        isOptedOut: "Excluido de la regla",
        optOutRule: "Optar por no participar en la regla global",
        optInRule: "Optar por la regla global",
        optedOutCustomers: "Clientes que optan por no participar",
        overriddenCustomers: "Clientes anulando",
        optOutRuleConfirm: "¿Está seguro de que desea excluirse de esta regla global?",
        optOutRuleConfirmTitle: "Optar por no participar en la regla global",
        optInRuleConfirm: "¿Está seguro de que desea suscribirse a esta regla global?",
        optInRuleConfirmTitle: "Optar por la regla global",
        overrideRuleConfirm: "¿Está seguro de que desea anular esta regla global?",
        overrideRuleConfirmTitle: "Anular regla global",
        threshold: "Límite",
        pageTitle: "Definiciones de alarma",
        configuration: "Configuración de alarma",
        id: "ID",
        name: "Nombre",
        isGlobal: "Regla global",
        isOverridden: "Anula la regla global",
        createdBy: "Creado Por",
        description: "Descripción",
        severity: "Gravedad*",
        standardDeviation: "Desviación Estándar",
        gaussian: "Gaussiano",
        thresholdRule: "Regla de umbral",
        clearRule: "Regla de liquidación",
        triggerCount: "Recuento de disparadores",
        activeAlarms: "Alarmas activas",
        lastTrigger: "Último disparador",
        filters: "Filtros",
        state: "Estado de regla",
        alarms: "Alarmas",
        lastHeard: "Último escuchado",
        atMost1Day: "A lo sumo 1 día",
        oneTo3Days: "1 to 3 Días",
        threeTo5Days: "3 a 5 Días",
        fiveTo7Days: "5 a 7 Días",
        atLeast7Days: "Mayor de 7 días",
        updateTime: "Última actualización",
        details: {
            title: "Detalles de la alarma",
            vswr: "VSWR",
            reflectedPower: "Poder Reflejado",
            forwardPower: "Poder Delantero",
            messageNumber: "Numero de mensaje",
            tower: {
                alarm: {
                    reflectedPower: "Poder Reflejado",
                    reflected : {
                        power: "Poder Reflejado"
                    },
                    forwardPower: "Poder Delantero",
                    forward : {
                        power: "Poder Delantero"
                    }
                }
            },
            idleNoiseDB: "Ruido Inactivo(db)",
            centerFrequencyHz: "Frecuencia Central",
            count: "",
            lastHeardTimestampMilli: "Última Escuchada",
            meter: {
                alarm: {
                    name: "Alarma",
                    snapshot: "Instantánea"
                }
            }
        },
        serviceErrors: {
            duplicateBarrier: "La regla de umbral debe ser única",
            standardDeviationError: "Error de procesamiento de la regla de desviación estándar",
            standardDeviationNoBaseStationError: "No se puede encontrar el ID de la estación base para la regla de desviación estándar",
            standardDeviationNoStoredDataError: "No se pueden encontrar estadísticas avanzadas almacenadas para la estación base",
            standardDeviationComputeError: "No se puede calcular la regla a partir de las estadísticas avanzadas de la estación base"
        },
        error: {
            dataRetrieval: "Error al Recuperar datos de alarma"
        }
    },
    metryAlarms: {
        pageTitle: "Alarmas Activas",
        min: "Min",
        max: "Max",
        columns: {
            suppressed: "Suprimida",
            suppressedBy: "Suprimido por",
            sourceClass: "Clase de Origen",
            sourceType: "Tipo de Fuente",
            sourceId: "ID de Fuente",
            referenceId: "Id de Referencia",
            deviceId: "ID de Dispositivo",
            sourceComponent: "Componente",
            alarmClass: "Clase de Alarma",
            alarmDefinition: "Definición de alarma",
            alarmType: "Tipo de alarma",
            severity: "Gravedad",
            startTime: "Hora de inicio",
            endTime: "Hora de finalización",
            ackTime: "Reconocido en",
            ackedBy: "Reconocido por",
            userName: "Creado Por",
            sourceName: "Nombre de la Fuente",
            location: "Lat/Long",
            details: {
                ruleId: "ID de regla",
            }
        },
        filters: {
            sourceClass: "Clase de Origen",
            sourceType: "Tipo de Fuente",
            sourceId: "ID de Fuente",
            referenceId: "Id de Referencia",
            deviceId: "ID de Dispositivo",
            sourceComponent: "Componente",
            alarmClass: "Clase de Alarma",
            alarmType: "Tipo de alarma",
            severity: "Gravedad",
            details: "Detalles",
            startTime: "Hora de inicio",
            endTime: "Hora de finalización",
            ackTime: "Reconocido en",
            ignoredBy: "Alarmas ignoradas",
            userName: "Creado Por",
            sourceName: "Nombre de la Fuente"
        },
        severity: {
            SEV10: "Crítico",
            SEV20: "Mayor",
            SEV30: "Menor",
            SEV40: "Información",
            SEV50: "Desconocida",
        },
        severityText: {
            Info: "Información",
            Minor: "Menor",
            Major: "Mayor",
            Critical: "Crítico",
            Unknown: "Desconocida"
        },
        ignoredAlarms: {
            "showIgnored": "Mostrar Alarmas Ignoradas Solamente",
            "hideIgnored": "Ocultar Alarmas Ignoradas"
        },
        actions: {
            actions: "Comportamiento",
            ack: "Reconocer",
            unack: "No reconocer",
            ignore: "Ignorar",
            unignore: "Desactivar",
            clear: "Claro",
            downloadCsv: "Descargar alarmas CSV",
            suppressAlarm: "Suprimir alarma",
            unsuppressAlarm: "Desactivar alarma",
            updateFailed:"No se pudieron actualizar las alarmas"
        },
        sourceClass: {
            TOWER: "Estación base",
            RADIO: "Radio",
            DEVICE: "Dispositivo",
            UNKNOWN: "Desconocida"
        },
        sourceComponent: {
            ANTENNA: "Antena",
            APPLICATION: "Solicitud",
            BATTERY: "Batería",
            DEVICE: "Dispositivo",
            ENCLOSURE: "Recinto",
            METER: "Metro",
            METROLOGY: "Metrología",
            POWER: "Poder",
            SENSOR: "Sensor",
            SMART_POINT: "Punto Inteligente",
            STATISTIC: "Estadística",
            UNKNOWN: "Desconocida"
        },
        alarmClass: {
            ENGINEERING: "Ingenieria",
            ENVIRONMENTAL: "Ambiental",
            EQUIPMENT: "Equipo",
            FEATURE: "Característica",
            POWER: "Poder",
            SECURITY: "Seguridad",
            SERVICE: "Servicio",
            THRESHOLD: "Límite",
            UNKNOWN: "Desconocida"
        },
    },
    alarmSuppression: {
        now: "Ahora",
        never: "Nunca",
        allAlarmTypes: "Todos los tipos de alarma",
        allBaseStations: "Todas las estaciones base",
        pageTitle: "Supresiones de alarma",
        createTitle: "Crear regla de supresión",
        editTitle: "Editar regla de supresión",
        alarmTypes: "Tipos de alarma",
        baseStation: "Estación base",
        lastSuppressionTime: "Hora de la última supresión",
        suppressionCount: "Recuento de supresión",
        save: "Ahorrar",
        createFail: "No se puede crear una regla de supresión de alarmas",
        createSuccess: "Regla de supresión creada",
        createAction: "Crear supresión de alarma",
        editSuccess: "Regla de supresión editada",
        editAction: "Editar supresión de alarma seleccionada",
        deleteAction: "Eliminar la supresión de alarma seleccionada",
        inactiveAction: "Hacer inactiva la supresión de alarma seleccionada",
        inactiveSuccess: "Regla de supresión inactiva",
        confirmInactive: "¿Está seguro de que desea desactivar esta regla de supresión?",
        confirmInactiveTitle: "Confirmar Hacer Inactiva",
        suppressionHistoryDetails: "Detalles del historial de supresión de alarmas",
        historyTooltip: "El historial de supresión tiene {cnt} entradas.  Haga clic en el icono para ver los detalles",
        commandSent: "Se realizó una llamada de supresión, dependiendo de la cantidad de alarmas coincidentes, esto puede tomar algún tiempo",
    }
}
